import { SimpleAlert } from '@cimplico/components';
import { useFirmContext } from '../providers/FirmProvider';

type XeroErrorAlertProps = {
    message: string;
    errorName: string;
    entityName?: string;
    entityId?: string;
    promptConnect?: boolean;
};

function XeroErrorAlert({ message, errorName, entityName, entityId, promptConnect = false }: XeroErrorAlertProps): JSX.Element | null {
    const { shortId } = useFirmContext();

    if (errorName === 'XeroForbiddenError' || errorName === 'XeroTokenRefreshError' || errorName === 'IntegrationError') {
        return (
            <SimpleAlert
                title={message.replace('The requested entity', entityName || 'The requested entity')}
                actionText={{
                    text: `Reconnect ${entityName}.`,
                    href: `/${shortId}/entities/${entityId}?tab=integrations&focusedIntegration=xero`,
                }}
                type="warn"
            />
        );
    }

    return (
        <SimpleAlert
            title={message}
            type="warn"
            actionText={
                promptConnect
                    ? {
                          text: `Reconnect ${entityName}.`,
                          href: `/${shortId}/entities/${entityId}?tab=integrations&focusedIntegration=xero`,
                      }
                    : undefined
            }
        />
    );
}
export default XeroErrorAlert;
